<script lang="ts">
    import ArrowButton from "./ArrowButton.svelte";
    import { logEvent } from "../../helpers/analytics";

    function onClick() {
        logEvent("learn_more");
    }
</script>

<ArrowButton text="Learn More" {onClick} green href={"/docs"} useLink={false} />
